/* eslint-disable max-len */
import './hint.css';

import classname from '@search/classname/src';

const cnHint = classname.bind(null, 'YMapHint');

export function yMapHintContainer(children: string) {
    return `<div class="${cnHint(null)}">${children}</div>`;
}

const emptyImage = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.12">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.35355 3.64645C3.15829 3.45118 2.84171 3.45118 2.64645 3.64645C2.45118 3.84171 2.45118 4.15829 2.64645 4.35355L20.6464 22.3536C20.8417 22.5488 21.1583 22.5488 21.3536 22.3536C21.5488 22.1583 21.5488 21.8417 21.3536 21.6464L3.35355 3.64645ZM2 9C2 7.93956 2.83643 7.06499 3.88214 7.00346L7.56665 10.688C7.19777 11.3954 7 12.1875 7 13C7 14.3261 7.52678 15.5979 8.46447 16.5355C9.40215 17.4732 10.6739 18 12 18C12.8125 18 13.6046 17.8022 14.312 17.4333L16.8787 20H4C2.9 20 2 19.1 2 18V9ZM9 13C9 12.7373 9.03451 12.4762 9.10222 12.2235L12.7765 15.8978C12.5254 15.9651 12.2645 16 12 16C11.606 16 11.2159 15.9224 10.8519 15.7716C10.488 15.6209 10.1573 15.3999 9.87868 15.1213C9.6001 14.8427 9.37913 14.512 9.22836 14.1481C9.0776 13.7841 9 13.394 9 13ZM11.2235 10.1022L14.8978 13.7765C14.9651 13.5254 15 13.2645 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10C11.7373 10 11.4762 10.0345 11.2235 10.1022ZM17 13C17 13.8125 16.8022 14.6046 16.4333 15.312L20.904 19.7827C21.553 19.4511 22 18.7752 22 18V9C22 7.9 21.1 7 20 7H17.6C17.4273 6.99212 17.2606 6.93399 17.1204 6.83273C16.9803 6.73148 16.8727 6.59151 16.811 6.43L16.19 4.569C16.1278 4.40767 16.02 4.26795 15.8797 4.1669C15.7394 4.06585 15.5727 4.00786 15.4 4H8.6C8.27 4 7.914 4.256 7.811 4.568L7.27973 6.15841L9.68797 8.56665C10.3954 8.19777 11.1875 8 12 8C13.3261 8 14.5979 8.52678 15.5355 9.46447C16.4732 10.4021 17 11.6739 17 13ZM19.5 10.2C19.3143 10.2 19.1363 10.1263 19.005 9.99497C18.8738 9.8637 18.8 9.68565 18.8 9.5C18.8 9.31435 18.8738 9.1363 19.005 9.00503C19.1363 8.87375 19.3143 8.8 19.5 8.8C19.6857 8.8 19.8637 8.87375 19.995 9.00503C20.1262 9.1363 20.2 9.31435 20.2 9.5C20.2 9.68565 20.1262 9.8637 19.995 9.99497C19.8637 10.1263 19.6857 10.2 19.5 10.2Z" fill="#1F212E"/>
</g>
</svg>`;

type IyMapHintPreview = {
    origin?: string;
    /** Полный путь */
    fullPath?: string;
}

export function yMapHintPreview(
    preview?: IyMapHintPreview
) {
    const { origin, fullPath } = preview ?? {};

    const path = fullPath ?? (origin ? `https://pic.m2.ru/size_84x64${origin}` : null);

    return `<div class="${cnHint('left')}">${
        path ? `<img class="${cnHint('preview')}" src="${path}" />` : emptyImage
    }</div>`;
}

export function yMapHintInfo(children: string) {
    return `<div class="${cnHint('right')}">${children}</div>`;
}

export function yMapHintTitle(children: string) {
    return `<div class="${cnHint('title')}">${children}</div>`;
}

export function yMapHintTitleLite(children: string) {
    return `<div class="${cnHint('title', { lite: true })}">${children}</div>`;
}

export function yMapHintDescription(children: string) {
    return `<div class="${cnHint('description')}">${children}</div>`;
}

export function yMapHintDescriptionLite(children: string) {
    return `<div class="${cnHint('description', { lite: true })}">${children}</div>`;
}

export function yMapHintDescriptionStatus(children: string) {
    return `<div class="${cnHint('description', { status: true })}">${children}</div>`;
}

export function yMapHintDescriptionPrice(children: string) {
    return `<div class="${cnHint('description', { price: true })}">${children}</div>`;
}
